import { Tab, type TabId, Tabs } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../../shared/Breadcrumb";
import { generatorPathItem } from "./GeneratorPath";
import { generatorPathName, generatorTabs } from "./generatorTabs";

export const PATH = generatorPathItem.path;
export const TITLE = generatorPathItem.label;

export function AdminGeneratorPage() {
  const { tabId } = useParams();
  const [activeTab, setActiveTab] = useState<TabId>(tabId ?? "root");
  useEffect(() => setActiveTab(tabId ?? "root"), [tabId]);
  const navigate = useNavigate();

  return (
    <article>
      <Breadcrumb path={[generatorPathItem]} />
      <Tabs
        selectedTabId={activeTab}
        onChange={(next) => {
          setActiveTab(next);
          navigate(generatorPathName(next), { replace: true });
        }}
        renderActiveTabPanelOnly
      >
        {Object.entries(generatorTabs).map(([id, tab]) => (
          <Tab key={id} id={id} icon={tab.icon} title={tab.label} panel={tab.panel} />
        ))}
      </Tabs>
    </article>
  );
}
